import { render, staticRenderFns } from "./VDocument.vue?vue&type=template&id=34f29c7a&"
import script from "./VDocument.vue?vue&type=script&lang=js&"
export * from "./VDocument.vue?vue&type=script&lang=js&"
import style0 from "./VDocument.vue?vue&type=style&index=0&id=34f29c7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports